import { motion } from "framer-motion";
import { BRAND, waLink } from "@/lib/site";
import { MapPin, Phone, Clock, MessageCircle } from "lucide-react";

const mapSrc =
  "https://www.google.com/maps?q=Rua%20de%20Santa%20Catarina%20274%20Porto&output=embed";

export default function Location() {
  return (
    <section
      id="localizacao"
      data-testid="location-section"
      className="py-24 md:py-36 bg-[#0A0A0A] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="lg:col-span-5"
          >
            <p className="text-[11px] tracking-[0.3em] uppercase text-neutral-400 mb-6 flex items-center gap-3">
              <span className="inline-block h-px w-10 bg-neutral-500" />
              Localização
            </p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Encontre-me <em className="italic">no centro do Porto.</em>
            </h2>

            <div className="mt-12 space-y-7">
              <div className="flex items-start gap-4">
                <MapPin className="h-5 w-5 mt-1 text-white" />
                <div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-400 mb-1">
                    Endereço
                  </div>
                  <div className="text-base text-white">
                    {BRAND.address.street}
                    <br />
                    {BRAND.address.detail}
                    <br />
                    {BRAND.address.city}
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Phone className="h-5 w-5 mt-1 text-white" />
                <div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-400 mb-1">
                    Telefone · WhatsApp
                  </div>
                  <a
                    href={waLink()}
                    target="_blank"
                    rel="noreferrer"
                    className="text-base text-white link-underline"
                    data-testid="location-phone"
                  >
                    {BRAND.whatsappDisplay}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Clock className="h-5 w-5 mt-1 text-white" />
                <div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-400 mb-1">
                    Horário
                  </div>
                  <div className="text-base text-white">
                    Apenas mediante marcação
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-12 flex flex-col sm:flex-row gap-3">
              <a
                href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(BRAND.address.full)}`}
                target="_blank"
                rel="noreferrer"
                data-testid="location-directions"
                className="inline-flex items-center justify-center gap-2 bg-white text-black px-7 py-4 text-[11px] tracking-[0.3em] uppercase hover:bg-neutral-200 transition-colors"
              >
                Como chegar
              </a>
              <a
                href={waLink("Olá Bianca! Gostaria de marcar uma visita ao estúdio.")}
                target="_blank"
                rel="noreferrer"
                data-testid="location-whatsapp"
                className="inline-flex items-center justify-center gap-2 border border-white/40 text-white px-7 py-4 text-[11px] tracking-[0.3em] uppercase hover:border-white transition-colors"
              >
                <MessageCircle className="h-4 w-4" />
                Falar comigo
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="lg:col-span-7"
          >
            <div
              className="relative aspect-[4/3] lg:aspect-square w-full bg-neutral-900 overflow-hidden border border-white/10"
              data-testid="map-embed-wrapper"
            >
              <iframe
                title="Mapa Bianca Sena Studio"
                src={mapSrc}
                width="100%"
                height="100%"
                style={{ border: 0, filter: "grayscale(100%) contrast(1.05)" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="map-iframe"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
